
// SVG Icon: ar-off
export default { id: "terriajs-ar-off" };
export const id = "terriajs-ar-off";
export const name = "ar-off";
